import { render, staticRenderFns } from "./PlatformStatement.vue?vue&type=template&id=716734a6&scoped=true"
import script from "./PlatformStatement.vue?vue&type=script&lang=js"
export * from "./PlatformStatement.vue?vue&type=script&lang=js"
import style0 from "./PlatformStatement.vue?vue&type=style&index=0&id=716734a6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "716734a6",
  null
  
)

export default component.exports